const tokenInput = document.querySelector<HTMLInputElement>(
  "input[type=hidden][name='token']"
)
export const TOKEN = tokenInput?.value
export const URL_CONF_PRODUCT = 'cart.php?a=confproduct'
export const URL_ADD_PRODUCT = 'cart.php?a=add'
export const URL_ADD_PRODUCT_WITH_DOMAIN = 'cart.php?a=add&domainselect=1'
export const URL_UPDATE_DOMAIN_PERIOD = 'cart.php?a=updateDomainPeriod'
export const URL_CONF_DOMAIN = 'cart.php?a=confdomains'
export const URL_CHECK_DOMAIN = 'index.php?rp=/domain/check'
